export default __webpack_public_path__ + "static/media/amazon_inverse.f01b147c.svg";